import React, { useRef } from 'react';
import LazyContext from '../../../LazyLoadingImage/LazyContext';
import { LAZYLOAD_ROW_START } from '../../../types';
import { useRowVisibility } from '../hooks/useRowVisibility';
import TorpedoContentStrip from './ContentStrip';
import HiddenRow from './HiddenRow';
import ItemRow from './ItemRow';
import OffsetTracking from './OffsetTracking';
import TorpedoItemElement from './TorpedoItem';
var TorpedoRow = function (_a) {
    var idx = _a.idx, width = _a.width, height = _a.height, layoutItems = _a.layoutItems, dataItems = _a.dataItems, contentStrip = _a.contentStrip, scrollOptims = _a.scrollOptims, onOffsetReached = _a.onOffsetReached, renderItem = _a.renderItem;
    var ref = useRef(null);
    var isVisible = useRowVisibility(ref, { enabled: scrollOptims });
    return (React.createElement(LazyContext.Provider, { value: idx >= LAZYLOAD_ROW_START },
        React.createElement(OffsetTracking, { rowIdx: idx, onOffsetReached: onOffsetReached },
            React.createElement("div", { ref: ref },
                isVisible ? (React.createElement(ItemRow, { rowIdx: idx, width: width, height: height, scrollOptims: scrollOptims }, layoutItems.map(function (layoutItem) { return (React.createElement(TorpedoItemElement, { key: "item-" + layoutItem.idx, layoutItem: layoutItem, dataItem: dataItems[layoutItem.dto.id], renderItem: renderItem })); }))) : (React.createElement(HiddenRow, { items: layoutItems, width: width, height: height })),
                contentStrip && (React.createElement(TorpedoContentStrip, { width: width }, contentStrip))))));
};
TorpedoRow.displayName = 'TorpedoRow';
export default TorpedoRow;
//# sourceMappingURL=TorpedoRow.js.map